import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const presentersListAction = createAsyncThunk(
    'presenters/list', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get(`/presenter/list?search=${reqBody?.searchValue}&page=${reqBody.page ? reqBody.page :0}&limit=${reqBody?.limit == undefined ? "" : reqBody?.limit}&sortKey=${reqBody?.sortKey == undefined ? "" :reqBody?.sortKey}&sortOrder=${reqBody?.sortOrder == undefined ? "" :reqBody?.sortOrder}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

    export const presentersSchoolListAction = createAsyncThunk(
        'presenters/SchoolList', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.get(`/presenter/all?search=${reqBody?.searchValue}`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    

export const presentersCreateAction = createAsyncThunk(
    'presenters/create', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.post('presenter/create', reqBody)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })
    export const removePresenterAction = createAsyncThunk(
        'presenters/removePresenterAction', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.post('school/remove-presenter', reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    
export const presentersUpdateAction = createAsyncThunk(
    'presenters/update', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.put(`/presenter/update`, reqBody)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

export const presentersDeleteAction = createAsyncThunk(
    'presenter/delete', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.delete(`/presenter/delete?id=${reqBody?.id}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })
